
import { Vue, Component } from 'vue-property-decorator'
import { ICellRendererParams } from 'ag-grid-community'

@Component({})
export default class ManagerSettingsPropertiesActionColumn extends Vue {
  params!: ICellRendererParams
}
